const ROUTES = {
  HOME: '/',
  SEARCH: '/search',
  SEARCH_CITY: '/s/:city',
  ACADEMY_PROFILE: '/academy/:slug',
  CLASS_ADMIN: '/class-admin',
  SUPER_ADMIN: '/super-admin',
  LOGIN: '/login',
  REGISTER: '/register',
  ABOUT: '/about',
  CONTACT: '/contact',
  TERMS: '/terms-conditions',
  PRIVACY: '/privacy-policy',
  SUPPORT: '/support',
  FAQS: '/faqs'
};

export default ROUTES;
